import React from 'react';
import { FILTER_IDENTIFIERS } from '../../../../constants/constants';
import { FORM_WIDGET_COMPONENTS, METADATA_NAMES } from '../../../../form/formConstants';
import FormWidget from '../../../../form/FormWidget';
import I18n from '../../../../i18n/I18n';

type NoteTagsInputProps = {
    value?: string[];
    onChange: (name: string, value: string[], noteId: string | null) => void;
};

export default function NoteTagsInput({ value = [], onChange }: NoteTagsInputProps) {
    return (
        <FormWidget
            component={FORM_WIDGET_COMPONENTS.metadataAutocomplete}
            metadataName={METADATA_NAMES.documentTag}
            value={value}
            identifier={FILTER_IDENTIFIERS.termset}
            onChange={onChange}
            multiple
            allowCreate
            name="labels"
            label={<I18n token="common.label.tag" />}
        />
    );
}
